export function getView(status) {
  return ['expired', 'revoked', 'inactive'].includes(status)
}
